import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserIcon, LockIcon, AlertCircleIcon } from 'lucide-react';
const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login,
    isAuthenticated
  } = useAuth();
  const navigate = useNavigate();
  // If already logged in, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" data-id="element-479" />;
  }
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }
    setIsLoading(true);
    try {
      const success = await login(username, password);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" data-id="element-480">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-481">
        <div className="bg-blue-600 p-6" data-id="element-482">
          <h2 className="text-2xl font-bold text-white text-center" data-id="element-483">
            Energy Meter Dashboard
          </h2>
          <p className="text-blue-100 text-center mt-1" data-id="element-484">
            Sign in to your account
          </p>
        </div>
        <div className="p-6" data-id="element-485">
          {error && <div className="mb-4 bg-red-50 border-l-4 border-red-500 p-4 rounded" data-id="element-486">
              <div className="flex items-center" data-id="element-487">
                <AlertCircleIcon className="h-5 w-5 text-red-500 mr-2" data-id="element-488" />
                <span className="text-red-700" data-id="element-489">{error}</span>
              </div>
            </div>}
          <form onSubmit={handleSubmit} data-id="element-490">
            <div className="mb-4" data-id="element-491">
              <label htmlFor="username" className="block text-gray-700 text-sm font-semibold mb-2" data-id="element-492">
                Username
              </label>
              <div className="relative" data-id="element-493">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-494">
                  <UserIcon className="h-5 w-5 text-gray-400" data-id="element-495" />
                </div>
                <input id="username" type="text" className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your username" value={username} onChange={e => setUsername(e.target.value)} data-id="element-496" />
              </div>
              <p className="mt-1 text-xs text-gray-500" data-id="element-497">
                Try "admin" or "user" for demo
              </p>
            </div>
            <div className="mb-6" data-id="element-498">
              <label htmlFor="password" className="block text-gray-700 text-sm font-semibold mb-2" data-id="element-499">
                Password
              </label>
              <div className="relative" data-id="element-500">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-501">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-502" />
                </div>
                <input id="password" type="password" className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} data-id="element-503" />
              </div>
              <p className="mt-1 text-xs text-gray-500" data-id="element-504">
                Try "admin123" or "user123" for demo
              </p>
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" disabled={isLoading} data-id="element-505">
              {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>;
};
export default Login;